<template>
  <div
    class="leaflet-component-box"
    data-trackleaf327482="none"
  >
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";

import robotGrey from "@/assets/images/map/robot_grey2.png";
import robotBlue from "@/assets/images/map/robot_blue2.png";
import langMap from '@/utils/language';
export default {
  props: {
    // 绘制区域用的颜色集
    areaColor: {
      type: Array,
      default: () => ["", "", ""]
    },
    // 历史路径颜色
    trackColor: {
      type: String,
      default: "#AB8B54"
    }
  },
  data() {
    return {
      langMap:langMap,
      name: "",
      sleep: false,
      flag: false,
      start: "",
      num: "1",
      timeList: [],
      value: 0,
      id: "",
      robotId: "",
      map: {},
      robotsLayer: [],
      version: {},
      status: {},
      movement: [],
      notice: [],
      level: "高",
      low: "低"
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      mapConfig: state => state.app.leafletConfig
    })
  },
  methods: {
    //初始化leaflet地图
    initMap(mapKey, mapUrl) {
      const tileLayerOption = this.mapConfig.tileLayerOption
      this.map = L.map("track_map_id", this.mapConfig.mapInstantiated);
      L.tileLayer(tileLayerOption.url, tileLayerOption).addTo(this.map);

      //添加绘制控制组件
      this.map.pm.setLang(this.lang || 'zh');

      //监听区域绘制完毕
      this.map.on("pm:create", e => {});
    },
    moveToCenter(point) {
      this.map.panTo([point[1], point[0]]);
    },

    //初始化绘制区域
    initTargetArea(areaList) {
      const dataList = areaList || [];

      dataList.forEach((item, index) => {
        if (item.area !== null) {
          let color = this.areaColor[item.type];

          let areas = JSON.parse(item.area);
          let areaTemp = [];
          areas.forEach((item1, index1, arr1) => {
            let point = [item1.lat, item1.lon];
            areaTemp[index1] = point;
          });
          console.info("[dataList>>>]", areaTemp);
          let polygon = L.polygon(areaTemp, {
            color: color,
            id: item.id
          }).addTo(this.map);

          // let _this = this;
          // //弹出信息层
          // polygon.on('click', (e)=> {
          //   _this.createPopup(item.tempId)
          // });
        }
      });
    },
    // 绘制入口(父组件调用)
    drawJobVision(robot, robotsLayer) {
      this.robotsLayer = robotsLayer;
      this.drawHistoryPath(robot);
      this.drawOrUpdateRobotPosition(robot);
    },
    //绘制或更新机器人实时位置
    drawOrUpdateRobotPosition(robot) {
      //查找层
      let layer;
      let order;
      const lastPosition = robot.lastPosition || [];

      this.robotsLayer.forEach((item, index, arr) => {
        if (item.id === robot.id) {
          layer = item;
          order = index;
        }
      });
      if (layer && layer.marker) {
        this.map.removeLayer(layer.marker);
      }
      // debugger;
      if (lastPosition.length > 0) {
        let robotIconUrl = robot.status === 1 ? robotBlue : robotGrey;
        let marker;

        let icon = new L.divIcon({
          html:
            '<div style="width: 100px;font-size: 12px;font-weight: 700;color: red;">' +
            robot.name +
            '</div><img src="' +
            robotIconUrl +
            '" style="width: 20px;height: 20px;" />',
          className: "my-div-icon",
          iconAnchor: [6, 28]
        });

        // leaflet坐标与amap相反
        marker = L.marker([lastPosition[1], lastPosition[0]], {
          icon: icon,
          title: robot.name,
          draggable: false,
          zIndexOffset: 1000,
          id: robot.id
        }).addTo(this.map);
        // 添加描述
        let content = this.genContent(robot);
        marker.bindPopup(content, { offset: L.point(0, -15) }).openPopup();

        /*弹出信息层
        marker.on('click', (e)=>{
          this.createPopup(item.id);
        });*/

        if (!layer) {
          this.robotsLayer.push({ id: robot.id, marker: marker });
        } else {
          layer = { ...layer, id: robot.id, marker: marker };
          this.$set(this.robotsLayer, order, layer);
        }
        // 通知父组件更新
        //this.$emit('updateLayer', this.robotsLayer);
      }
    },
    //绘制任务已经执行的路径
    drawHistoryPath(robot) {
      //查找层
      let layer;
      let order;
      const points = robot.hisPoints;
      this.robotsLayer.forEach((item, index, arr) => {
        if (item.id === robot.id) {
          layer = item;
          order = index;
        }
      });
      if (layer && layer.hisPath) {
        this.map.removeLayer(layer.hisPath);
      }
      if (!points.length) {
        return;
      }
      let path = [];
      const len = points.length;
      for (let i = 0, item; i < len; i++) {
        item = points[i];
        path.push({ x: item.var2, y: item.var1 });
      }

      // 使用simplify.js简化后的路径（去除部分不必要的点）
      const simplifyPath = L.LineUtil.simplify(path, 0.000005);
      // 处理为leaflet使用的点
      let finishPath = [];
      for (let i = 0, item; i < simplifyPath.length; i++) {
        item = simplifyPath[i];
        finishPath.push([item.x, item.y]);
      }
      let _config = this.mapConfig;
      let mapPolyline = L.polyline(finishPath, {
        opacity: 1, //透明度
        stroke: true, // 线周围绘制边框
        color: _config.trackColor,
        weight: _config.trackWidth + 2
      }).addTo(this.map);

      if (!layer) {
        this.robotsLayer.push({
          id: robot.id,
          hisPath: mapPolyline
        });
      } else {
        layer = { ...layer, id: robot.id, hisPath: mapPolyline };
        this.$set(this.robotsLayer, order, layer);
      }
      // 通知父组件更新
      //this.$emit('updateLayer', this.robotsLayer);
    },
    genContent(robot) {
      let html =
        '<div class="input-card content-window-card"><div style="padding:2px;"><h4>' +
        this.name +
        "</h4>" +
        '<p class="input-item">' + langMap.power[this.lang] + ':' +
        (robot.statusData && robot.statusData.stateOfCharge
          ? robot.statusData.stateOfCharge.value
          : "-") +
        "</p>" +
        '<p class="input-item">' + langMap.speedHtml[this.lang] + ':' +
        (robot.movementData ? robot.movementData.speed : "-") +
        "/" + langMap.direction[this.lang] + ":" +
        (robot.movementData ? robot.movementData.direction : "-") +
        "</p>" +
        "</div></div>";
      return html;
    }
  }
};
</script>

<style lang="less">
.leaflet-component-box[data-trackleaf327482] {
  height: 100%;
  /* 窗口闪烁问题解决 */
  .leaflet-fade-anim {
    .leaflet-popup {
      transition: none;
      -webkit-transition: none;
    }
  }
}
</style>


